import { rpc } from "src/composables/Rpc";
import { Guid, Integerlike } from "src/interfaces/InleagueApiV1";

export const getCompetitionUIDsForInvoices = rpc<{invoiceInstanceIDs: Integerlike[]}, {competitionUID: Guid, invoiceInstanceID: Integerlike}[]>("get", "v1/playerEditor/getCompetitionUIDsForInvoices")
